import "./DiamondLoader.css";

const DiamondLoader = ({ duration = 5 }) => {
  return (
    <div className="diamond-container">
      <svg
        className="diamond-svg"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ "--animation-duration": `${duration}s` }}
      >
        {/* <!-- Center facet --> */}
        <path
          className="facet facet1"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M27.9887 44.8358L24.666 36.9364L27.8969 29.0154L35.7973 25.6958L43.7421 28.9422L47.0648 36.8416L43.8266 44.7646L35.9273 48.0822L27.9887 44.8358Z"
        />

        {/* <!-- Top right facets --> */}
        <path
          className="facet facet2"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M35.7979 25.6963L43.7436 28.9416L46.9849 20.5864L35.7979 25.6963Z"
        />
        <path
          className="facet facet3"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M49.7763 14.4016C45.608 13.0383 40.8312 12.2556 35.7451 12.2814L46.9847 20.586L49.7763 14.4016Z"
        />
        <path
          className="facet facet4"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M46.9844 20.5863L55.6366 16.9212C53.8731 15.9384 51.9003 15.1021 49.776 14.4019L46.9844 20.5863Z"
        />

        {/* <!-- Top left facets --> */}
        <path
          className="facet facet5"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M35.7977 25.6963L27.8901 29.0201L24.5674 20.6958L35.7977 25.6963Z"
        />
        <path
          className="facet facet6"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M35.7461 12.2817L35.7471 12.4168L35.7265 12.2817L24.5684 20.6957L35.7915 25.6931H35.8121L46.9846 20.5864L35.7461 12.2817Z"
        />
        <path
          className="facet facet7"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21.7168 14.5396C25.8717 13.135 30.6381 12.3069 35.7253 12.2832L24.5682 20.6972L21.7168 14.5396Z"
        />
        <path
          className="facet facet8"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M24.5671 20.6962L15.8809 17.1146C17.633 16.1164 19.6006 15.2594 21.7157 14.5386L24.5671 20.6962Z"
        />

        {/* <!-- Bottom left facets --> */}
        <path
          className="facet facet9"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M35.9084 48.0838L27.9678 44.8364L24.7266 53.1937L35.9084 48.0838Z"
        />
        <path
          className="facet facet10"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21.9346 59.3762C26.1029 60.7354 30.8776 61.5212 35.9637 61.4964L24.7262 53.1938L21.9346 59.3762Z"
        />
        <path
          className="facet facet11"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M24.7262 53.1934L16.0771 56.8533C17.8375 57.836 19.8134 58.6796 21.9357 59.3757L24.7262 53.1934Z"
        />

        {/* <!-- Bottom right facets --> */}
        <path
          className="facet facet12"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M35.9082 48.0836L43.82 44.7578L47.1437 53.0852L35.9082 48.0836Z"
        />
        <path
          className="facet facet13"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M35.9651 61.4958V61.3576L35.9868 61.4958L47.1439 53.0849L35.9208 48.0864L35.9012 48.2308L35.9002 48.0864L24.7266 53.1932L35.9651 61.4958Z"
        />
        <path
          className="facet facet14"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M49.9948 59.239C45.8399 60.6404 41.0714 61.4716 35.9863 61.4953L47.1434 53.0845L49.9948 59.239Z"
        />
        <path
          className="facet facet15"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M47.1436 53.085L55.8318 56.6603C54.0777 57.6616 52.1121 58.5238 49.995 59.2395L47.1436 53.085Z"
        />

        {/* <!-- Left facets --> */}
        <path
          className="facet facet16"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M24.6613 36.9431L27.9118 29.0045L19.5566 25.7612L24.6613 36.9431Z"
        />
        <path
          className="facet facet17"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.3739 22.9692C12.0024 27.1396 11.2258 31.9153 11.2506 37.0004L19.5563 25.7629L13.3739 22.9692Z"
        />
        <path
          className="facet facet18"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M27.8763 28.9884L27.9114 29.0049L27.8711 28.9616L24.5681 20.6961L15.9066 17.127L15.8921 17.1084L15.8963 17.1218L15.8818 17.1146L15.8983 17.1352L19.5562 25.7616L27.8516 28.976L27.8897 29.0193L27.8763 28.9884Z"
        />
        <path
          className="facet facet19"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.5564 25.7616L15.8923 17.1084C14.9106 18.8687 14.0701 20.8456 13.374 22.969L19.5564 25.7616Z"
        />
        <path
          className="facet facet20"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M24.6614 36.9434L27.9893 44.852L19.665 48.1788L24.6614 36.9434Z"
        />
        <path
          className="facet facet21"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.25 37.0008L11.3851 36.9997L11.25 37.0142L19.665 48.1785L24.6604 36.9482L24.516 36.9358H24.6614L19.5567 25.7622L11.25 37.0008Z"
        />
        <path
          className="facet facet22"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.5105 51.0242C12.0977 46.8735 11.2758 42.108 11.25 37.0137L19.664 48.178L13.5105 51.0242Z"
        />
        <path
          className="facet facet23"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M27.9489 44.8942L27.9891 44.8519L27.9541 44.8623L27.9675 44.8354L27.9293 44.8736L19.6649 48.1788L16.0926 56.8371L16.0771 56.8536H16.0895L16.0875 56.8629L16.0998 56.8474L24.7262 53.1937L27.9489 44.8942Z"
        />
        <path
          className="facet facet24"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.6652 48.1782L16.0878 56.8634C15.0875 55.1123 14.2264 53.1447 13.5107 51.0245L19.6652 48.1782Z"
        />

        {/* <!-- Right facets --> */}
        <path
          className="facet facet25"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M47.0523 36.8325L43.8008 44.7752L52.1601 48.0195L47.0523 36.8325Z"
        />
        <path
          className="facet facet26"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M58.3436 50.8051C59.7079 46.6399 60.4855 41.8673 60.4607 36.7739L52.1592 48.0187L58.3436 50.8051Z"
        />
        <path
          className="facet facet27"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M55.8179 56.661L55.8313 56.6589L55.8107 56.6476L52.1591 48.0191L43.8585 44.7965L43.8204 44.7583L43.8327 44.7841L43.8008 44.7758L43.8389 44.8191L47.1431 53.0846L55.8045 56.6527L55.8252 56.6692L55.8179 56.661Z"
        />
        <path
          className="facet facet28"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M52.1592 48.019L55.8253 56.6692C56.807 54.9078 57.6434 52.9319 58.3436 50.8044L52.1592 48.019Z"
        />
        <path
          className="facet facet29"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M47.0525 36.8323L43.7236 28.9267L52.051 25.603L47.0525 36.8323Z"
        />
        <path
          className="facet facet30"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M60.4612 36.773L60.323 36.774L60.4612 36.7606L52.0503 25.6035L47.0508 36.8266L47.1952 36.839H47.0508L52.1596 48.0188L60.4612 36.773Z"
        />
        <path
          className="facet facet31"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M58.2073 22.7505C59.614 26.9064 60.4369 31.6718 60.4617 36.76L52.0508 25.6029L58.2073 22.7505Z"
        />
        <path
          className="facet facet32"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M55.617 16.9418L55.6387 16.9212L55.6243 16.9274L55.6325 16.916L55.6109 16.9346L46.9844 20.5862L43.7628 28.8837L43.7236 28.927L43.7556 28.9105L43.7432 28.9425L43.7824 28.9002L52.051 25.6033L55.617 16.9418Z"
        />
        <path
          className="facet facet33"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M52.0498 25.6038L55.6313 16.9155C56.6286 18.6645 57.4855 20.6352 58.2053 22.7514L52.0498 25.6038Z"
        />

        {/* <!-- Highlight facet --> */}
        <path
          className="facet facet34"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M43.7431 28.9421L35.7973 25.6968L27.8979 29.0153L24.667 36.9364L26.4005 41.0696L46.3336 35.1121L43.7431 28.9421Z"
        />
      </svg>
    </div>
  );
};

export default DiamondLoader;